const viewModes = {
  FULLSCREEN: 'FULLSCREEN',
  BLOCK: 'BLOCK',
};
export default viewModes;
